import { Observable } from 'rxjs';
import { BranchResponse } from '../models/branch-response.model';
import { BranchParams } from '../models/branch.model';

export abstract class BranchesRepository {
    abstract findBranches(
        BranchParams: BranchParams,
    ): Observable<BranchResponse>;
}
